/**
 * Snapshot regenerator utility for storing and restoring branch state
 */
export interface BranchSnapshot {
  branchId?: string;
  brandId?: string;
  groupId?: string;
}

export class BranchSnapshotRegenerator {
  /**
   * Store snapshot in location state
   */
  static storeSnapshot(
    snapshot: BranchSnapshot,
    currentPathname: string,
    navigate: (
      path: string,
      options?: { replace?: boolean; state?: unknown }
    ) => void
  ) {
    navigate(currentPathname, {
      replace: true,
      state: snapshot,
    });
  }

  /**
   * Restore snapshot from location state
   * Can also handle BrandSnapshot or GroupSnapshot which have different fields
   */
  static restoreSnapshot(locationState: unknown): BranchSnapshot | null {
    if (locationState && typeof locationState === "object") {
      const state = locationState as Record<string, unknown>;
      return {
        branchId:
          typeof state.branchId === "string" ? state.branchId : undefined,
        brandId: typeof state.brandId === "string" ? state.brandId : undefined,
        groupId: typeof state.groupId === "string" ? state.groupId : undefined,
      };
    }
    return null;
  }
}
